module.exports = __webpack_public_path__ + "img/bg.c873c44b.jpg";